// utils/mexicoFeedsConfig.js - COMPLETE VERSION WITH STATES

// Mexico state information lookup table
const mexicoStateInfo = {
  aguascalientes: { fullName: 'Aguascalientes', code: 'ags', flagImage: '/aguascalientesFlag.png', tableName: 'aguascalientes' },
  bajacalifornia: { fullName: 'Baja California', code: 'bc', flagImage: '/bajaCaliforniaFlag.png', tableName: 'baja_california' },
  bajacaliforniasur: { fullName: 'Baja California Sur', code: 'bcs', flagImage: '/bajaCaliforniaSurFlag.png', tableName: 'baja_california_sur' },
  campeche: { fullName: 'Campeche', code: 'camp', flagImage: '/campecheFlag.png', tableName: 'campeche' },
  chiapas: { fullName: 'Chiapas', code: 'chis', flagImage: '/chiapasFlag.png', tableName: 'chiapas' },
  chihuahua: { fullName: 'Chihuahua', code: 'chih', flagImage: '/chihuahuaFlag.png', tableName: 'chihuahua' },
  coahuila: { fullName: 'Coahuila', code: 'coah', flagImage: '/coahuilaFlag.png', tableName: 'coahuila' },
  colima: { fullName: 'Colima', code: 'col', flagImage: '/colimaFlag.png', tableName: 'colima' },
  durango: { fullName: 'Durango', code: 'dur', flagImage: '/durangoFlag.png', tableName: 'durango' },
  guanajuato: { fullName: 'Guanajuato', code: 'gto', flagImage: '/guanajuatoFlag.png', tableName: 'guanajuato' },
  guerrero: { fullName: 'Guerrero', code: 'gro', flagImage: '/guerreroFlag.png', tableName: 'guerrero' },
  hidalgo: { fullName: 'Hidalgo', code: 'hgo', flagImage: '/hidalgoFlag.png', tableName: 'hidalgo' },
  jalisco: { fullName: 'Jalisco', code: 'jal', flagImage: '/jaliscoFlag.png', tableName: 'jalisco' },
  mexicocity: { fullName: 'Ciudad de México', code: 'cdmx', flagImage: '/mexicoCityFlag.png', tableName: 'mexico_city' },
  mexicostate: { fullName: 'Estado de México', code: 'edomex', flagImage: '/mexicoStateFlag.png', tableName: 'mexico_state' },
  michoacan: { fullName: 'Michoacán', code: 'mich', flagImage: '/michoacanFlag.png', tableName: 'michoacan' },
  morelos: { fullName: 'Morelos', code: 'mor', flagImage: '/morelosFlag.png', tableName: 'morelos' },
  nayarit: { fullName: 'Nayarit', code: 'nay', flagImage: '/nayaritFlag.png', tableName: 'nayarit' },
  nuevoleon: { fullName: 'Nuevo León', code: 'nl', flagImage: '/nuevoLeonFlag.png', tableName: 'nuevo_leon' },
  oaxaca: { fullName: 'Oaxaca', code: 'oax', flagImage: '/oaxacaFlag.png', tableName: 'oaxaca' },
  puebla: { fullName: 'Puebla', code: 'pue', flagImage: '/pueblaFlag.png', tableName: 'puebla' },
  queretaro: { fullName: 'Querétaro', code: 'qro', flagImage: '/queretaroFlag.png', tableName: 'queretaro' },
  quintanaroo: { fullName: 'Quintana Roo', code: 'qroo', flagImage: '/quintanaRooFlag.png', tableName: 'quintana_roo' },
  sanluispotosi: { fullName: 'San Luis Potosí', code: 'slp', flagImage: '/sanLuisPotosiFlag.png', tableName: 'san_luis_potosi' },
  sinaloa: { fullName: 'Sinaloa', code: 'sin', flagImage: '/sinaloaFlag.png', tableName: 'sinaloa' },
  sonora: { fullName: 'Sonora', code: 'son', flagImage: '/sonoraFlag.png', tableName: 'sonora' },
  tabasco: { fullName: 'Tabasco', code: 'tab', flagImage: '/tabascoFlag.png', tableName: 'tabasco' },
  tamaulipas: { fullName: 'Tamaulipas', code: 'tamps', flagImage: '/tamaulipasFlag.png', tableName: 'tamaulipas' },
  tlaxcala: { fullName: 'Tlaxcala', code: 'tlax', flagImage: '/tlaxcalaFlag.png', tableName: 'tlaxcala' },
  veracruz: { fullName: 'Veracruz', code: 'ver', flagImage: '/veracruzFlag.png', tableName: 'veracruz' },
  yucatan: { fullName: 'Yucatán', code: 'yuc', flagImage: '/yucatanFlag.png', tableName: 'yucatan' },
  zacatecas: { fullName: 'Zacatecas', code: 'zac', flagImage: '/zacatecasFlag.png', tableName: 'zacatecas' }
};

// Factory function to create Mexican state update feed
export function createMexicanStateUpdateFeed(stateKey) {
  const s = mexicoStateInfo[stateKey];
  if (!s) return null;
  return {
    id: `${s.code}Updates`,
    displayType: 'normal',
    name: `${s.fullName} Updates`,
    apiParams: `&skip=0&schema=mexico&table=${s.tableName}&order_by=created_at`,
    feedBranch: 'Updates',
    feedTopic: 'N/A',
    buttonName: 'Document',
  };
}

// Get Mexican state update feed as array
export function getMexicanStateUpdateFeed(stateKey) {
  const feed = createMexicanStateUpdateFeed(stateKey);
  return feed ? [feed] : [];
}

// Get all Mexican state update feeds
export function getAllMexicanStateUpdateFeeds() {
  return Object.keys(mexicoStateInfo)
    .map(createMexicanStateUpdateFeed)
    .filter(Boolean);
}

// Factory function to create Mexican state feeds (currently returns empty for future expansion)
function createMexicanStateFeeds(stateKey) {
  const s = mexicoStateInfo[stateKey];
  if (!s) return null;
  return {
    legislative: [],
    executive: [],
    judicial: [],
  };
}

// Helper function to get Mexican state info
export const getMexicanStateInfo = (stateKey) => mexicoStateInfo[stateKey];

// Helper function to get Mexican state feeds by branch
export const getMexicanStateFeedsByBranch = (stateKey, branch) => {
  const stateFeeds = createMexicanStateFeeds(stateKey);
  if (!stateFeeds) return [];
  return stateFeeds[branch.toLowerCase()] || [];
};

// Main Mexico feeds config (your existing configuration)
export const mexicoFeedsConfig = {
  // Schema-level recents: one feed that hits
  // https://api.govglance.org/posts/recent/schema?limit=<n>&skip=0&schema=mexico
  // (no table -> useFeedData routes it to /posts/recent/schema). The limit is
  // driven by the maxItems each view requests.
  recent: [
    {
      id: 'recent-mex-0',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico',
      title: 'Recents',
      feedName: 'Recents',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/mexico/recents',
      showOnHomePage: true
    }
  ],

  legislative: [
    {
      id: 'se',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=senado_de_la_republica&order_by=created_at',
      title: 'Senate',
      feedName: 'Senate',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/mexico/legislative',
      showOnHomePage: true
    }
  ],

  executive: [
    {
      id: "president",
      type: "normal",
      apiEndpoint: "&skip=0&schema=mexico&table=presidente&order_by=created_at",
      title: "President Newsroom",
      feedName: "President Newsroom",
      branch: "Executive",
      topic: "N/A",
      buttonName: "Doc",
      viewAllLink: "/mexico/executive",
      showOnHomePage: true
    },
    {
      id: "executiveNews",
      type: "normal",
      apiEndpoint: "&skip=0&schema=mexico&table=agricultura&order_by=created_at",
      title: "Secretaría de Agricultura y Desarrollo Rural",
      feedName: "Secretaría de Agricultura y Desarrollo Rural",
      branch: "Executive",
      topic: "Environment",
      buttonName: "Doc",
      viewAllLink: "/mexico/executive",
      showOnHomePage: false
    },
    {
      id: "welfare",
      type: "normal",
      apiEndpoint: "&skip=0&schema=mexico&table=bienestar&order_by=created_at",
      title: "Secretaría de Bienestar",
      feedName: "Secretaría de Bienestar",
      branch: "Executive",
      topic: "N/A",
      buttonName: "Doc",
      viewAllLink: "/mexico/executive",
      showOnHomePage: false
    },
    {
      id: "cjef",
      type: "normal",
      apiEndpoint: "&skip=0&schema=mexico&table=cjef&order_by=created_at",
      title: "Consejería Jurídica del Ejecutivo Federal",
      feedName: "Consejería Jurídica del Ejecutivo Federal",
      branch: "Executive",
      topic: "N/A",
      buttonName: "Doc",
      viewAllLink: "/mexico/executive",
      showOnHomePage: false
    },
    // Add remaining executive feeds here...
  ],

  judicial: [
    {
      id: 'sc',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=suprema_corte_de_justicia_de_la_nacion&order_by=created_at',
      title: 'Supreme Court',
      feedName: 'Supreme Court',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/mexico/judicial',
      showOnHomePage: true
    }
  ],

  defense: [
    {
      id: 'sedena',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=sedena&order_by=created_at',
      title: 'Secretaría de la Defensa Nacional',
      feedName: 'Secretaría de la Defensa Nacional',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Doc',
      viewAllLink: '/mexico/defense',
      showOnHomePage: true
    }
  ],

  economy: [
    {
      id: 'se',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=se&order_by=created_at',
      title: 'Secretaría de Economía',
      feedName: 'Secretaría de Economía',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/mexico/economy',
      showOnHomePage: true
    },
    {
      id: 'sectur',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=sectur&order_by=created_at',
      title: 'Secretaría de Turismo',
      feedName: 'Secretaría de Turismo',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/mexico/economy',
      showOnHomePage: false
    },
    {
      id: 'shcp',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=shcp&order_by=created_at',
      title: 'Secretaría de Hacienda y Crédito Público',
      feedName: 'Secretaría de Hacienda y Crédito Público',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/mexico/economy',
      showOnHomePage: false
    }
  ],

  environment: [
    {
      id: 'executiveNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=agricultura&order_by=created_at',
      title: 'Secretaría de Agricultura y Desarrollo Rural',
      feedName: 'Secretaría de Agricultura y Desarrollo Rural',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/mexico/environment',
      showOnHomePage: true
    },
    {
      id: 'conafor',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=conafor&order_by=created_at',
      title: 'Comisión Nacional Forestal',
      feedName: 'Comisión Nacional Forestal',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/mexico/environment',
      showOnHomePage: false
    },
    {
      id: 'sct',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=sct&order_by=created_at',
      title: 'Secretaría de Comunicaciones y Transportes',
      feedName: 'Secretaría de Comunicaciones y Transportes',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/mexico/environment',
      showOnHomePage: false
    },
    {
      id: 'sedatu',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=sedatu&order_by=created_at',
      title: 'Secretaría de Desarrollo Agrario, Territorial y Urbano',
      feedName: 'Secretaría de Desarrollo Agrario, Territorial y Urbano',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/mexico/environment',
      showOnHomePage: false
    },
    {
      id: 'semarNat',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=semarnat&order_by=created_at',
      title: 'Secretaría de Medio Ambiente y Recursos Naturales',
      feedName: 'Secretaría de Medio Ambiente y Recursos Naturales',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/mexico/environment',
      showOnHomePage: false
    }
  ],

  foreignAffairs: [
    {
      id: 'inm',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=inm&order_by=created_at',
      title: 'Instituto Nacional de Migración',
      feedName: 'Instituto Nacional de Migración',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Doc',
      viewAllLink: '/mexico/foreign-affairs',
      showOnHomePage: true
    },
    {
      id: 'sedena',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=sedena&order_by=created_at',
      title: 'Secretaría de la Defensa Nacional',
      feedName: 'Secretaría de la Defensa Nacional',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Doc',
      viewAllLink: '/mexico/foreign-affairs',
      showOnHomePage: false
    },
    {
      id: 'semar',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=semar&order_by=created_at',
      title: 'Secretaría de Marina',
      feedName: 'Secretaría de Marina',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Doc',
      viewAllLink: '/mexico/foreign-affairs',
      showOnHomePage: false
    },
    {
      id: 'sre',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=sre&order_by=created_at',
      title: 'Secretaría de Relaciones Exteriores',
      feedName: 'Secretaría de Relaciones Exteriores',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Doc',
      viewAllLink: '/mexico/foreign-affairs',
      showOnHomePage: false
    }
  ],

  health: [
    {
      id: 'salud',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=salud&order_by=created_at',
      title: 'Secretaría de Salud',
      feedName: 'Secretaría de Salud',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/mexico/health',
      showOnHomePage: true
    },
    {
      id: 'conade',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=conade&order_by=created_at',
      title: 'Comisión Nacional de Cultura Física y Deporte',
      feedName: 'Comisión Nacional de Cultura Física y Deporte',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/mexico/health',
      showOnHomePage: false
    },
    {
      id: 'conadis',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=conadis&order_by=created_at',
      title: 'Consejo Nacional para el Desarrollo y la Inclusión de las Personas con Discapacidad',
      feedName: 'Consejo Nacional para el Desarrollo y la Inclusión de las Personas con Discapacidad',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/mexico/health',
      showOnHomePage: false
    },
    {
      id: 'stps',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=stps&order_by=created_at',
      title: 'Secretaría del Trabajo y Previsión Social',
      feedName: 'Secretaría del Trabajo y Previsión Social',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/mexico/health',
      showOnHomePage: false
    }
  ],

  infrastructure: [
    {
      id: 'sct',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=sct&order_by=created_at',
      title: 'Secretaría de Comunicaciones y Transportes',
      feedName: 'Secretaría de Comunicaciones y Transportes',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/mexico/infrastructure',
      showOnHomePage: true
    },
    {
      id: 'sedatu',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=mexico&table=sedatu&order_by=created_at',
      title: 'Secretaría de Desarrollo Agrario, Territorial y Urbano',
      feedName: 'Secretaría de Desarrollo Agrario, Territorial y Urbano',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/mexico/infrastructure',
      showOnHomePage: false
    }
  ],

  // Add states section to the config
  states: Object.fromEntries(
    Object.keys(mexicoStateInfo).map((k) => [k, getMexicanStateUpdateFeed(k)])
  )
};

// Helper functions
export const getFeedsByType = (sectionKey, type = 'normal') => {
  const sectionFeeds = mexicoFeedsConfig[sectionKey] || [];
  return sectionFeeds.filter(feed => feed.type === type);
};

export const getNormalFeeds = (sectionKey) => {
  return getFeedsByType(sectionKey, 'normal');
};

export const getCarouselFeeds = (sectionKey) => {
  return getFeedsByType(sectionKey, 'carousel');
};